import { client } from '@/common-utils/libraries/axios/axios';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import { REMOTE_COLLECTION } from '../../api/apiUrls';
const mutationSendTransactionByMail = (onSuccess, onError) => {
    return {
        mutationFn: ({ transactionId, provider, emails }) => {
            return client.post(replaceParameters(
                REMOTE_COLLECTION.TRANSACTIONS.SEND_MAIL.url, { transactionId: transactionId }),
                { provider: provider, recipients: emails.join(',') }
            );
        },
        onError: (error) => {
            onError(error);
        },
        onSuccess: () => {
            onSuccess();
        },
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSendTransactionByMail;